import { showConfirmation } from './showConfirmation';
import { showMissingFonts } from './showMissingFonts';
import { showNotification } from './showNotification';
import { showNotificationAccessError } from './showNotificationAccessError';
import { showNotUpdatedLayouts } from './showNotUpdatedLayouts';
import { success, warn } from './toasts';
import { errorV2, loadingV2, successV2, warningV2 } from './toastsV2';

export const Notifications = {
  // modal windows
  showConfirmation,
  showMissingFonts,
  showNotUpdatedLayouts,
  showNotification,
  showNotificationAccessError,

  // toasts
  success,
  warn,
  // new toasts
  successV2,
  errorV2,
  warningV2,
  loadingV2,
};
